/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Component } from 'react';
import Content from './login.content';
import { getContent, buildErrorMsgFromForm, getDefaultLanding } from '../../actions/utils';
import { withRouter } from 'react-router-dom';
import Logo from '../../_shared/logo';
import { Form, Input, Alert } from 'antd';
import styles from '../authentication.styles';
import SharedStyles from '../../_shared/styles';
import { Button } from '../../_shared/button';
import { getPublicRoutes } from '../../dashboard/dashboard.routes';
import { get } from 'lodash';

class LoginComponent extends Component {
  state = {
    error: null,
    loading: false,
    isSignUp: false,
    mfaRequired: false,
  };
  componentDidMount = () => {
    const { state } = this.props.history.location;
    const {
      form: { setFields, setFieldsValue },
    } = this.props;

    if (state && state.signUp) {
      setFields({
        email: {
          value: state.signUp,
        },
      });
      this.setState({ isSignUp: true });
    } else if (state && !state.redirectTo) {
      // Card #283 — a deep link (e.g. /recon/:id from a scanned QR) arrives as
      // history state too, but redirectTo is not a form field: handing it to
      // setFieldsValue would warn about an unregistered field.
      setFieldsValue(state);
    }
  };
  goToForgotPassword = () => {
    this.props.history.push('/forgotPassword');
  };
  signInSubmit = async (e) => {
    e.preventDefault();
    if (this.state.loading) {
      return;
    }

    this.state.loading = true;
    this.state.error = null;
    this.setState(this.state);

    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        const error = buildErrorMsgFromForm(err);
        return this.setState({ error, loading: false });
      }
      const { email, password, mfaToken } = values;

      const _email = email.toLowerCase();

      const req = await this.props.signIn(_email, password, mfaToken);

      if (req && req.mfaRequired) {
        // Either the code is needed for the first time, or the entered one was wrong.
        return this.setState({
          mfaRequired: true,
          loading: false,
          error: this.state.mfaRequired ? (req.error || 'Invalid code. Please try again.') : null,
        });
      }

      if (req && req.mfaEnrollRequired) {
        return this.setState({
          loading: false,
          error: req.error || 'Two-factor authentication enrollment is required. Contact an administrator.',
        });
      }

      if (!req || req.success === false) {
        return this.setState({
          error: (req && req.error) || 'That username and password combination is not valid',
          loading: false,
        });
      } else {
        // Card #283 — when the user got here from a deep link (a scanned Recon
        // Form QR sends them to /recon/:id), return them to it so they are not
        // dropped on the dashboard and forced to rescan.
        const redirectTo = get(this.props, 'history.location.state.redirectTo');
        const role = get(this.props, 'sState.user.role');
        this.props.history.push(redirectTo || getDefaultLanding(role));
      }
    });
  };
  signUpToggle = () => {
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      this.props.history.push('/signup', values);
    })
  }
  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { error, loading, isSignUp } = this.state;
    const btnDisabled = !(getFieldValue('email') && getFieldValue('password'));
    const content = getContent(Content);
    const publicRoutes = getPublicRoutes();

    return (
      <div className="Login" css={css(styles.container)}>
        <div css={css(SharedStyles.logoWrap)}>
          <Logo />
        </div>

        <p css={css(styles.title)}>
          {isSignUp ? content.signUp : content.signIn}
        </p>

        {!!error && (
          <Alert
            message={error}
            type={'error'}
            closable
            onClose={() => this.setState({ error: null })}
          />
        )}

        <div css={css(styles.inputContainer)}>
          <Form layout="vertical" onSubmit={this.signInSubmit}>
            <Form.Item label={content.emailLabel}>
              {getFieldDecorator('email', {
                validateTrigger: 'onBlur',
                rules: [
                  {
                    type: 'email',
                    message: 'The input is not a valid E-mail. ',
                  },
                  {
                    required: true,
                    message: 'The input is not a valid E-mail. ',
                  },
                  {
                    max: 60,
                    message: 'Email is limited to 60 characters. ',
                  },
                ],
              })(<Input />)}
            </Form.Item>
            <Form.Item label={content.passwordLabel}>
              {getFieldDecorator('password', {
                validateTrigger: 'onBlur',
                rules: [
                  {
                    required: true,
                    message: 'Please input your password!',
                  },
                ],
              })(<Input.Password onPressEnter={this.signInSubmit} />)}
            </Form.Item>

            {this.state.mfaRequired && (
              <Form.Item label={'Authenticator Code'}>
                {getFieldDecorator('mfaToken', {
                  rules: [
                    {
                      required: true,
                      message: 'Enter your 6-digit authenticator code',
                    },
                  ],
                })(
                  <Input
                    placeholder="6-digit code"
                    maxLength={6}
                    autoFocus
                    onPressEnter={this.signInSubmit}
                  />
                )}
              </Form.Item>
            )}

            {!isSignUp && (
              <div
                onClick={this.goToForgotPassword}
                css={css(styles.fgPassword)}
              >
                {content.forgotPasswordBtn}
              </div>
            )}

            <Form.Item>
              <div css={css(styles.buttonContainer)}>
                <Button
                  loading={loading}
                  onClick={this.signInSubmit}
                  disabled={btnDisabled}
                  type={"primary"}
                  css={css(styles.button)}
                >
                  {isSignUp ? content.buttonSignUp : content.button}
                </Button>

                <Button
                  outline={true}
                  loading={loading}
                  onClick={this.signUpToggle}
                  css={css(styles.button)}
                >
                  {isSignUp ? 'Cancel' : content.buttonSignUp}
                </Button>
              </div>
            </Form.Item>
          </Form>
        </div>

        <div css={css(styles.linkContainer)}>
          {publicRoutes.filter(r => get(r, 'showOnLanding', true)).map(r => (
            <div>
              <a href={r.path}>{get(r, 'landingTitle', r.title)}</a>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export const Login = Form.create()(withRouter(LoginComponent));
